import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  makeStyles,
  Typography
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles(theme => ({
  grid: {
    height: "100vh",
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.palette.common.white
  }
}));

const Loader = () => {
  const { t } = useTranslation();
  const classes = useClasses();
  const [showLoadingText, setShowLoadingText] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoadingText(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Grid
      className={classes.grid}
      container
      justify="center"
      alignItems="center"
      direction="column"
      spacing={2}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
      {showLoadingText && (
        <Grid item lg={2}>
          <Box textAlign="center">
            <Typography gutterBottom>
              <strong>{t("components.loader.title")}</strong>
            </Typography>
            <Typography>{t("components.loader.intro_text")}</Typography>
            <Typography>{t("components.loader.no_refresh_text")}</Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export { Loader };
